/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Detail_Applications_No_Slots_NoticeInputs */

const en_job_detail_applications_no_slots_notice = /** @type {(inputs: Job_Detail_Applications_No_Slots_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create interview slots to accept applications and book interviews.`)
};

const de_job_detail_applications_no_slots_notice = /** @type {(inputs: Job_Detail_Applications_No_Slots_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legen Sie Termine an, um Bewerbungen anzunehmen und Gespräche zu buchen.`)
};

/**
* | output |
* | --- |
* | "Create interview slots to accept applications and book interviews." |
*
* @param {Job_Detail_Applications_No_Slots_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_detail_applications_no_slots_notice = /** @type {((inputs?: Job_Detail_Applications_No_Slots_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Detail_Applications_No_Slots_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_detail_applications_no_slots_notice(inputs)
	return en_job_detail_applications_no_slots_notice(inputs)
});